module.exports = __webpack_public_path__ + "static/media/map marker.57761f43.svg";